// src/components/auth/InitialAuthCheck.js
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const InitialAuthCheck = () => {
    const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

    useEffect(() => {
        const verifyWithDjango = async () => {
            try {
                if (!isAuthenticated) {
                    console.log('User not authenticated, skipping Django verification');
                    return;
                }

                console.log('Initiating Django authentication...');
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                        scope: "openid profile email"
                    }
                });

                console.log('Got Auth0 token, verifying with Django...');
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/verify/`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`Django verification failed: ${response.statusText}`);
                }

                const data = await response.json();
                console.log('Django authentication successful:', data);
            } catch (error) {
                console.error('Error during initial authentication:', error);
            }
        };

        if (!isLoading) {
            verifyWithDjango();
        }
    }, [isAuthenticated, isLoading, getAccessTokenSilently]);

    return null;
};

export default InitialAuthCheck;